import { ICandidate, IAccount, IInbox } from '../../../interfaces/graph-types';
import { AccountService } from '../../../services/account.service';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IFunnel } from '../../../interfaces/graph-types';
import { Observable, Subject, Subscription, BehaviorSubject } from 'rxjs';
import { Apollo, gql } from 'apollo-angular-boost';
import { PaginationTemplate } from '../../../interfaces/pagination';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

type onSelectFunnel = (
  funnelId: string,
  onsuccess: onSmartSuccess,
  onfailure: onSmartFailure,
) => void;

@Component({
  selector: 'modal-funnel-selector',
  template: require('./modal-funnel-selector.component.pug'),
  styles: [require('./modal-funnel-selector.component.css').toString()],
})
export class ModalFunnelSelectorComponent implements OnInit {
  funnels$: Observable<IFunnel[]>;

  // Options to pass to the modal:
  accountId: string;
  onSelect: onSelectFunnel;

  itemPerPage = 30;
  maxSize = 10;
  currentPage: number = 1;
  highlightFunnel: IFunnel = null;
  totalCount = null;

  // -------------------------------------------------------------------
  constructor(public bsModalRef: BsModalRef, private apollo: Apollo) {
    this.countTotal = new BehaviorSubject<number>(0);
  }

  // -------------------------------------------------------------------
  isLoading() {
    return this.funnelPagination.isLoading();
  }

  // -------------------------------------------------------------------
  buildQuery() {
    return this.apollo.watchQuery<{ account: IAccount }>({
      query: gql`
        query funnelPagination(
          $first: Int
          $last: Int
          $after: String
          $before: String
          $skip: Int
          $accountId: ID!
          $searchFilter: String
          $archived: Boolean
          $logonId: ID
        ) {
          account(accountId: $accountId) {
            id
            funnelList(
              first: $first
              last: $last
              after: $after
              before: $before
              skip: $skip
              searchFilter: $searchFilter
              archived: $archived
              logonId: $logonId
            ) {
              totalCount
              pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
              }
              edges {
                node {
                  id
                  name
                  live
                  applicationCount
                  createdAt
                  cacheTotal
                  cacheOpen
                  rateOpen
                  cacheClick
                  rateClick
                  cacheReply
                  rateReply
                  cacheUnsub
                  rateUnsub
                  owner {
                    id
                    name
                  }
                  inboxes {
                    id
                    name
                    email
                  }
                  preview
                }
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: false,
    });
  }

  searchFilter = { include_tags: [], in_group: null };
  searchChanged: Subject<any> = new Subject<any>();

  // -------------------------------------------------------------------
  setPage(newPage: number) {
    if (this.currentPage == newPage) {
      return;
    }
    this.currentPage = newPage;
    this.funnelPagination.setOffset((newPage - 1) * this.itemPerPage);
  }

  filter: string = '';

  archived = false;
  mine = false;

  funnelPagination: PaginationTemplate<IFunnel>;

  countTotal: BehaviorSubject<number>;

  // -------------------------------------------------------------------
  ngOnInit() {
    // this.funnels$ = this.accountService.quickFunnels(
    //   this.accountId,
    //   false,
    //   null,
    // );

    const query = this.buildQuery();

    this.funnelPagination = new PaginationTemplate<IFunnel>(
      this.apollo,
      this.accountId,
      query,
      'account',
      'funnelList',
      null,
      null,
      this.searchFilter,
      () => {
        if (this.totalCount == null) {
          this.totalCount = this.funnelPagination.totalCount; // to prevent that an empty search displays that the org has no account at all
        }
        this.countTotal.next(this.funnelPagination.totalCount);
      },
    );

    this.searchChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(model => this.startSearch(model));
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {}

  // -------------------------------------------------------------------
  allInboxes(funnel: IFunnel) {
    let text = '';
    funnel.inboxes.forEach((inbox: IInbox) => {
      text = text + ' ' + inbox.email;
    });
    return text;
  }

  // -------------------------------------------------------------------
  valueChanged(newvalue) {
    this.searchChanged.next(newvalue);
  }

  // -------------------------------------------------------------------
  startSearch(newvalue) {
    this.filter = newvalue;
    this.funnelPagination.searchFilter.text = newvalue;
    this.funnelPagination.setOffset(0, () => {});
  }

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  private selectedFunnel: IFunnel;

  // -------------------------------------------------------------------
  setFunnel(funnel: IFunnel) {
    this.selectedFunnel = funnel;
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.onSelect(this.selectedFunnel.id, onsuccess, onfailure);
  }
}
